export default {
  setWorkplace(state, value) {
    state.workplace = value
  },

  setWorkplaces(state, value) {
    state.workplaces = value
  },

  setWorkplaceFilters(state, filters) {
    state.workplaceFilters = filters
  },
}
